import { render, staticRenderFns } from "./BiodigestorHistoryDatatableWidgetComponent.vue?vue&type=template&id=35f46fa6&"
import script from "./BiodigestorHistoryDatatableWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./BiodigestorHistoryDatatableWidgetComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports